import React from 'react';
import { motion } from 'framer-motion';

const ChessSquare = ({ piece, isLight, isSelected, isValidMove, onClick, row, col }) => {
  const getPieceSymbol = (piece) => {
    if (!piece) return '';
    
    const symbols = {
      white: {
        king: '♔',
        queen: '♕',
        rook: '♖',
        bishop: '♗',
        knight: '♘',
        pawn: '♙'
      },
      black: {
        king: '♚',
        queen: '♛',
        rook: '♜',
        bishop: '♝',
        knight: '♞',
        pawn: '♟'
      }
    };
    
    return symbols[piece.color][piece.type] || '';
  };

  const baseClasses = `
    w-12 h-12 flex items-center justify-center cursor-pointer
    transition-all duration-200 relative
    hover:scale-105 hover:shadow-lg
  `;
  
  const bgColor = isLight ? 'bg-amber-50' : 'bg-amber-600';
  const selectedBg = isSelected ? 'ring-4 ring-blue-400 ring-opacity-75' : '';
  const validMoveBg = isValidMove ? 'ring-2 ring-green-400' : '';

  return (
    <motion.div
      className={`${baseClasses} ${bgColor} ${selectedBg} ${validMoveBg}`}
      onClick={onClick}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: (row * 8 + col) * 0.01 }}
    >
      {/* Row numbers */}
      {col === 0 && (
        <span className="absolute -left-6 text-amber-800 font-semibold text-sm">
          {8 - row}
        </span>
      )}
      
      {/* Valid move indicator */}
      {isValidMove && !piece && (
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          className="w-4 h-4 bg-green-400 rounded-full opacity-60"
        />
      )}
      
      {/* Valid capture indicator */}
      {isValidMove && piece && (
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          className="absolute inset-0 border-4 border-red-400 rounded-full opacity-60"
        />
      )}
      
      {/* Chess piece */}
      {piece && (
        <motion.span
          className="text-4xl select-none"
          initial={{ scale: 0, rotate: -180 }}
          animate={{ scale: 1, rotate: 0 }}
          transition={{ type: "spring", stiffness: 200, damping: 15 }}
          whileHover={{ scale: 1.1 }}
        >
          {getPieceSymbol(piece)}
        </motion.span>
      )}
    </motion.div>
  );
};

export default ChessSquare;